
































import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";

import AutomatedInvestmentFunding from "@/shared/components/investments/drivewealth/sweep/AutomatedInvestmentFunding.vue";
import SweepManaged from "@/shared/components/investments/drivewealth/sweep/SweepManaged.vue";
import RiskDisclaimer from "@/shared/components/investments/drivewealth/RiskDisclaimer.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";
import {
  DrivewealthWizardStep,
  DrivewealthAccountManagementType
} from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useInvestmentDailyBalanceStore } from "@/shared/store/investmentDailyBalance";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";

@Component({
  computed: {
    DrivewealthAccountManagementType () {
      return DrivewealthAccountManagementType;
    }
  },
  components: {
    GenericLoadingSpinner,
    SweepManaged,
    RiskDisclaimer,
    AutomatedInvestmentFunding,
  }
})
export default class SweepPage extends Vue {
  @Prop({ required: true })
  isPreenrollment: boolean;

  @Prop({ required: false, default: false })
  isUserOnboarding: boolean;

  drivewealthStore = useDrivewealthStore();
  investmentStore = useInvestmentDailyBalanceStore();
  drivewealthWizardStore = useDrivewealthWizardStore();

  mounted () {
    this.drivewealthStore.loadDefaultAccount();
    this.investmentStore.loadHsaBalanceAndThreshold({});
    this.drivewealthWizardStore.loadExistingPreenrollment({});
  }

  get isLoaded () {
    return this.drivewealthStore.drivewealthLoaded && this.investmentStore.isHsaBalanceAndThresholdLoaded
      && this.drivewealthWizardStore.isEnrollmentLoaded;
  }

  get investmentLanding () {
    return RouteNames.InvestmentAccountInfo;
  }

  get isStandalone () {
    return !this.isPreenrollment && !this.isUserOnboarding;
  }

  warnBeforeRouteLeave = false;
  warnBeforeRouteLeaveMessage = "";

  beforeRouteLeave (to, from, next) {
    if (this.warnBeforeRouteLeave) {
      const userWantsToLeave = window.confirm(this.warnBeforeRouteLeaveMessage);
      if (userWantsToLeave) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  }

  onNavigationGuardChange (data: { confirmNavigation: boolean; message: string }) {
    this.warnBeforeRouteLeave = data.confirmNavigation;
    this.warnBeforeRouteLeaveMessage = data.message;
  }

  showThisSweep (invstmentManagementType: string) {
    return (this.drivewealthStore.hasAnAccount &&
      this.drivewealthStore.isAccountManagementType(invstmentManagementType))
      || (this.drivewealthWizardStore.isPreenrolled && this.drivewealthWizardStore.enrollmentAccountType ===
        invstmentManagementType);
  }

  onComplete () {
    if (this.isUserOnboarding) {
      this.drivewealthWizardStore.setWizardStepComplete(DrivewealthWizardStep.AutomatedFunding);
      return;
    } // routing from here handled by the wizard.

    this.$router.push({ name: RouteNames.InvestmentAccountInfo });
  }
}
